import { useQuery } from 'react-query'
import request from '../../../request'
import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import { GoogleServiceUser } from '@demandlocal/utils/lib/mongo/models/GoogleServiceUsers'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useGetGoogleServiceUser = () => {
  const dealership = useDealership()
  return useQuery(['service_email'], ({ signal }) =>
    request<GoogleServiceUser>({
      url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/customers/sources/spreadsheet/service_email`,
      method: 'GET',
      signal,
    }).then((res: any) => res.data),
  )
}
